export const FeatureTogglerTestIds = {
  TOGGLE_ALL_CHECKBOX: 'feature-toggler.toggle-all-checkbox',
};
